module.exports = __webpack_public_path__ + "img/potrait.e99909c0.png";